import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { Settings as SettingsIcon, Mail, Building2, Shield, KeyRound, ArrowRight } from "lucide-react";

export default function Settings() {
  const { user, business } = useAuth();
  return (
    <div className="max-w-3xl px-6 md:px-10 py-10 md:py-14">
      <div className="mb-8">
        <div className="text-[10px] uppercase tracking-[0.25em] text-muted-foreground mb-3">/ Settings</div>
        <h1 className="text-3xl sm:text-4xl tracking-tight font-medium flex items-center gap-3">
          <SettingsIcon className="w-6 h-6 text-muted-foreground" strokeWidth={1.5} />
          Settings
        </h1>
      </div>

      <div className="space-y-4">
        <section className="border border-border rounded-sm bg-card p-5">
          <h2 className="text-sm font-medium mb-3 inline-flex items-center gap-2"><Mail className="w-4 h-4" strokeWidth={1.5} /> Account</h2>
          <div className="grid grid-cols-3 gap-3 text-sm">
            <div className="text-muted-foreground text-xs uppercase tracking-widest">Email</div>
            <div className="col-span-2 font-mono">{user?.email}</div>
            <div className="text-muted-foreground text-xs uppercase tracking-widest">Role</div>
            <div className="col-span-2 font-mono">{user?.role}</div>
            <div className="text-muted-foreground text-xs uppercase tracking-widest">Created</div>
            <div className="col-span-2 font-mono">{user?.created_at && new Date(user.created_at).toLocaleString()}</div>
          </div>
        </section>

        {business && (
          <section className="border border-border rounded-sm bg-card p-5">
            <h2 className="text-sm font-medium mb-3 inline-flex items-center gap-2"><Building2 className="w-4 h-4" strokeWidth={1.5} /> Business</h2>
            <div className="grid grid-cols-3 gap-3 text-sm">
              <div className="text-muted-foreground text-xs uppercase tracking-widest">Legal name</div>
              <div className="col-span-2">{business.legal_name}</div>
              <div className="text-muted-foreground text-xs uppercase tracking-widest">VPA</div>
              <div className="col-span-2 font-mono">{business.full_vpa}</div>
              <div className="text-muted-foreground text-xs uppercase tracking-widest">Country</div>
              <div className="col-span-2 font-mono">{business.country || "—"}</div>
              <div className="text-muted-foreground text-xs uppercase tracking-widest">Status</div>
              <div className="col-span-2 font-mono">{business.status}</div>
            </div>
          </section>
        )}

        <Link
          to="/app/settings/api-keys"
          data-testid="settings-apikeys-link"
          className="block border border-border rounded-sm bg-card p-5 hover:border-foreground transition-colors"
        >
          <div className="flex items-center justify-between gap-3">
            <div>
              <h2 className="text-sm font-medium inline-flex items-center gap-2">
                <KeyRound className="w-4 h-4" strokeWidth={1.5} /> API keys
              </h2>
              <p className="text-xs text-muted-foreground mt-1">
                Long-lived <code className="font-mono">neopay_bk_*</code> keys for SDKs, Zapier, and your own backends.
              </p>
            </div>
            <ArrowRight className="w-4 h-4 text-muted-foreground" strokeWidth={1.5} />
          </div>
        </Link>

        <section className="border border-border rounded-sm bg-card p-5">
          <h2 className="text-sm font-medium mb-3 inline-flex items-center gap-2"><Shield className="w-4 h-4" strokeWidth={1.5} /> JWT bearer auth</h2>
          <p className="text-xs text-muted-foreground">
            For interactive UI sessions only. Use API keys above for any non-human integration.
          </p>
        </section>
      </div>
    </div>
  );
}
